//
//
//
//
//
//

const sideClasses = {
  left: 'lg:pr-2',
  'left-gutter': 'lg:pr-4',
  right: 'lg:pl-2'
}
const widthClasses = {
  '1/3': 'lg:w-1/3',
  '2/3': 'lg:w-2/3',
  '1/2': 'lg:w-1/2',
  '1/5': 'lg:w-1/5',
  '4/5': 'lg:w-4/5',
  '1/4': 'lg:w-1/4',
  '3/4': 'lg:w-3/4'
}

export default {
  name: 'Column',
  props: {
    side: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: true
    }
  },
  computed: {
    sideClass() {
      return sideClasses[this.side]
    },
    widthClass() {
      return widthClasses[this.width]
    }
  }
}
